import styles from "./styles.module.scss";
import Section from "../../../components/Section";

import figma_icon from "../../../graphics/figma_icon.svg";

import web_1 from "../../../images/web_1.png";
import web_2 from "../../../images/web_2.png";
import web_3 from "../../../images/web_3.png";
import web_4 from "../../../images/web_4.png";
import web_5 from "../../../images/web_5.png";
import web_6 from "../../../images/web_6.png";

const Travel = () => {
  return (
    <Section>
      <div className={styles.container}>
        <h2 className={styles.title}>
          Дизайн сайта агентства по продаже туров в Турцию
        </h2>
        <div className={styles.content}>
          <div className={styles.item}>
            <h4 className={styles.subtitle}>Бизнес-задача</h4>
            <p className={styles.text}>
              Создать сайт, который погружает пользователей в атмосферу Турции,
              отображая её культурное богатство и привлекая внимание к
              уникальным предложениям компании.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Процесс решения</h4>
            <p className={styles.text}>
              Для передачи колорита страны я подобрала цветовую палитру,
              изображения и графику, характерные для турецкой культуры. Главной
              целью было сделать навигацию интуитивной, чтобы пользователь легко
              находил туры и дополнительные сервисы.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Color palette</h4>
            <div className={styles.palette_container}>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#1D1D1D" }}
              >
                <p>
                  Black <br /> #1D1D1D
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#39AC03" }}
              >
                <p>
                  Green <br /> #39AC03
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#5F8989" }}
              >
                <p>
                  Blue <br /> #5F8989
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#868686" }}
              >
                <p>
                  Light-gray <br /> #868686
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#FFFFFF" }}
              >
                <p>
                  White <br /> #FFFFFF
                </p>
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Fonts</h4>
            <div className={styles.fonts_container}>
              <div className={styles.font}>
                <div className={styles.sans}>
                  <p className={styles.colored}>Aa</p>
                  <p>Open Sans</p>
                </div>
              </div>
              <div className={styles.font}>
                <div className={styles.raleway}>
                  <p className={styles.colored}>Aa</p>
                  <p>Raleway</p>
                </div>
              </div>
              <div className={styles.font}>
                <div className={styles.turkishye}>
                  <p className={styles.colored}>Aa</p>
                  <p>Turkishye</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Layout Grid</h4>
            <div className={styles.layout_container}>
              <p>12 columns</p>
              <p>150 margin</p>
              <p>32 gutter</p>
            </div>
          </div>
        </div>

        <div className={styles.images}>
          <div className={styles.row}>
            <div className={styles.item}>
              <img src={web_1} alt="" />
            </div>
            <div className={styles.item}>
              <img src={web_2} alt="" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.item}>
              <img src={web_3} alt="" />
            </div>
            <div className={styles.item}>
              <img src={web_4} alt="" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.item}>
              <img src={web_5} alt="" />
            </div>
            <div className={styles.item}>
              <img src={web_6} alt="" />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Travel;
